module.exports = __webpack_public_path__ + "img/menu-bg.5ae6fd56.jpg";